<template>
  <div class="ELYXModalBox" :style="getCustomStyles">
    <slot></slot>
  </div>
</template>

<script>
import { ELYXCentralStore } from "../ELYX/ELYXStore";

export default {
  computed: {
    activeModal: () => ELYXCentralStore.state.activeModal,

    getCustomStyles() {
      let styles = ``;
      if (this.$windowHeight <= this.activeModal.heightBreakOff) {
        styles += `
          height: 100vh;
          overflow-y: scroll;
          border-radius: 0px;
          justify-content: flex-start;
        `;
      }
      if (this.$windowWidth <= this.activeModal.widthBreakOff) {
        styles += `
          max-width: unset;
          width: 100vw;
          border-radius: 0px;
        `;
      }
      if (this.activeModal.isInfoModal) {
        styles += `
          width: 650px;
          height: 95vh;
          overflow-y: scroll;
          justify-content: flex-start;
          border-radius: 16px !important;
        `;
      }
      return styles;
    },
  },
};
</script>

<style>
.ELYXModalBox {
  padding: 25px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  width: 415px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: white;
  min-width: 415px;
}
</style>
